import React from 'react';
import './styles.css';

interface ErrorRetryProps {
	title?: string;
	error: string;
	retryCount: number;
	maxRetries?: number;
	onRetry: () => void;
	onReload?: () => void;
	retryButtonText?: (count: number, max: number) => string;
	reloadButtonText?: string;
}

export const ErrorRetry: React.FC<ErrorRetryProps> = ({
	title = 'Configuration Error',
	error,
	retryCount,
	maxRetries = 3,
	onRetry,
	onReload = () => window.location.reload(),
	retryButtonText = (count, max) => `Try Again (${count}/${max})`,
	reloadButtonText = 'Reload Page',
}) => {
	return (
		<div className="error-retry">
			<div className="error-retry-container">
				<h2>{title}</h2>
				<p>{error}</p>
				{retryCount < maxRetries && (
					<button onClick={onRetry} className="error-retry-button error-retry-button--primary">
						{retryButtonText(retryCount, maxRetries)}
					</button>
				)}
				{retryCount >= maxRetries && (
					<button onClick={onReload} className="error-retry-button error-retry-button--secondary">
						{reloadButtonText}
					</button>
				)}
			</div>
		</div>
	);
};

export default ErrorRetry;